import script from "./AdminDeleteRequests.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDeleteRequests.vue?vue&type=script&setup=true&lang=js"

import "./AdminDeleteRequests.vue?vue&type=style&index=0&id=4e465836&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e465836"]])

export default __exports__